<template>
  <div class="fb fb-col height-full relative pb-136 bd-box">
    <div>
      <md-searchbar v-model="keyword"></md-searchbar>
      <div
        ref="breadcrumbs"
        class="bt h-44 p-0-16 font-32 fb fb-cross-center bg-FFFFFF address-nav"
        v-show="!keyword"
      >
        <div
          v-for="(item, index) in breadList"
          :key="index"
          @click="back(item, index)"
          class="inline-block max-w-180"
        >
          <div class="fb fb-cross-center fb-main-center">
            <span
              :class="[
                index >= breadList.length - 1 ? 'c-171A1D-60' : 'c-006AFE'
              ]"
              class="inline-block"
              >{{ deptMaxName(item.deptName) }}</span
            >
            <i
              class="iconfont font-28 c-171A1D-40 p-0-4"
              v-if="index < breadList.length - 1"
              >&#xe68d;</i
            >
          </div>
        </div>
      </div>
    </div>
    <p class="p-0-16 pt-16 c-111F2C-60 font-28" v-show="!keyword"
      >未录入{{ unFacedCount }}人</p
    >
    <div
      v-if="personList.length"
      class="bg-F6F6F6 p-0-8 p-16-0 fb fb-main-start fb-cross-start fb-wrap mt-12 scroll-y"
    >
      <div
        @click="handlerPerson(item)"
        v-for="(item, index) in personList"
        :key="`face-${index}`"
        class="fb fb-col fb-cross-center fb-main-center face-margin"
      >
        <div
          class="w-76 h-76 bd-radio-8 bg-FFFFFF fb fb-cross-center fb-main-center face-pic hidden"
        >
          <img width="100%" v-if="item.facePicUrl" :src="item.facePicUrl" />
          <i
            v-else
            class="iconfont font-72"
            :class="[item.face ? 'c-006AFE' : 'c-191A26-24']"
            >&#xe67b;</i
          >
        </div>
        <p class="pt-12 pb-16 font-28">{{
          filterName(item.name || item.memberName || item.studentName, 4)
        }}</p>
      </div>
    </div>
    <div v-if="deptList.length" class="item-flex-1 scroll-y p-0-16 pb-16">
      <div
        class="font-34 ff-regular bg-FFFFFF mt-12 p-0-16 bd-radio-8"
        v-for="(item, index) in deptList"
        @click="nextSeason(item)"
        :key="index"
      >
        <div class="h-56 fb fb-main-between fb-cross-center">
          <div class="item-flex-1 text-ellipsis c-171A1D font-34">
            <span class="mr-8">{{ item.deptName || item.memberName }}</span>
            <span>({{ item.studentCnt }})</span>
          </div>
          <div class="font-28 pl-10">
            <span class="c-111F2C-40"
              >未录入{{ item.studentCnt - item.selStudentCnt }}人</span
            ><i class="c-111F2C-60 iconfont">&#xe66b;</i></div
          >
        </div>
      </div>
    </div>
    <div
      v-if="!deptList.length && !personList.length"
      class="relative item-flex-1"
    >
      <common-no-data class="no-record w-fullVw h-258">
        <div class="no-course no-item"></div>
        <p class="font-28 c-171A1D-40">暂无记录</p>
      </common-no-data>
    </div>
    <div
      class="footer h-auto fb fb-col fb-main-end fb-cross-center p-16-0"
      v-if="showBottom && !keyword"
    >
      <md-button v-if="computedFaceStudent" class="mb-16" @click="dingNotice(0)"
        >通知家长授权学校录脸</md-button
      >
      <md-button @click="dingNotice(computedFaceStudent ? 1 : 2)"
        >通知{{
          computedFaceStudent ? '家长录入学生人脸' : '大家录入人脸'
        }}</md-button
      >
    </div>
  </div>
</template>

<script>
import {
  deepCopy,
  filterName,
  setItem,
  getItem,
  faceUrl,
  deptMaxName,
  getTitle
} from '@/utils/comUtils'
import {} from '@/utils/constUtils'
import mixin from '@/mixin'
import {
  mcSetTitle,
  mcHidePreloader,
  mcShowPreloader,
  mcAlert,
  mcCreateMessage
} from '@/utils/mcSdkUtils'
import { commonNoData } from '@/components'
export default {
  name: 'PageMemberFace',
  mixins: [mixin],
  components: {
    commonNoData
  },
  data() {
    return {
      filterName,
      deptMaxName,
      unFacedCount: 0,
      isLoading: false,
      showBottom: true,
      timer: null,
      deptList: [],
      keyword: '',
      isDestroyed: false,
      breadList: [],
      parentNode: {
        deptId: '',
        deptName: getTitle(),
        deptTpId: ''
      },
      personList: [],
      faceSandBoxId: '',
      faceSandBoxType: +this.$route.query.faceSandBoxType || 14 // 14: 学生人脸信息，15：教职工人脸信息，16：家长人脸信息
    }
  },
  watch: {
    async keyword(newValue, oldValue) {
      if (newValue) {
        this.getPerson(newValue)
      } else {
        oldValue && (this.showBottom = true)
        this.taskPolling()
      }
    }
  },
  computed: {
    computedFaceStudent() {
      return this.faceSandBoxType === 14
    }
  },
  created() {},
  mounted() {
    console.log('mounted')
    !this.computedFaceStudent && mcSetTitle('家长人脸录入管理')
    this.breadList = [this.parentNode]
    this.init()
    this.getFaceAuth()
    this.visibilityChange()
  },
  activated() {
    console.log('activated')
    if (this.keyword) {
      this.getPerson(this.keyword)
    } else {
      this.getSubNodes()
    }
  },
  destroyed() {
    this.isDestroyed = true
  },
  beforeRouteUpdate(to, from) {
    // document.removeEventListener('visibilitychange', this.visibilityHandler)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setFaceSandBoxId', this.faceSandBoxId)
    const blen = this.breadList.length
    const flag = to.path.indexOf('/faceInput/faceFrame') > -1
    console.log(to, flag)
    if (this.keyword && !flag) {
      this.keyword = ''
      next(false)
    } else if (blen > 1 && !flag) {
      this.back(this.breadList[blen - 2], blen - 2)
      next(false)
    } else {
      clearTimeout(this.timer)
      this.timer = null
      next()
    }
  },
  methods: {
    init() {
      console.log('init*****')
      mcShowPreloader({ text: '初始化···' })
      if (this.faceSandBoxId) {
        this.taskPolling()
      } else {
        this.createSandBox()
      }
    },
    visibilityChange() {
      document.addEventListener('visibilitychange', this.visibilityHandler)
    },
    visibilityHandler() {
      const pageVisibility = document.visibilityState
      // 页面变为不可见时触发
      if (pageVisibility === 'hidden') {
        console.log('离开时间点：' + new Date())
      }
      // 页面变为可见时触发
      if (pageVisibility === 'visible') {
        console.log('重新进入时间点：' + new Date())
        if (this.keyword) {
          this.getPerson(this.keyword)
        } else {
          this.getSubNodes()
        }
      }
    },
    getPerson(newValue) {
      let api = 'faceStudentInfo'
      let param = {
        keyWord: newValue,
        pageNum: 1,
        pageSize: 30,
        campusId: this.campusId,
        orgId: this.orgId
      }
      if (!this.computedFaceStudent) {
        api = 'faceOrgMember'
        param = {
          memberName: newValue,
          operUserRoleTypes: this.currentRole,
          campusId: this.campusId
        }
      }
      this.getApi(api, {
        ...param,
        ...this.commonParams,
        operUserDingId: this.dingUserId,
        operUserName: this.dingUserName
      }).then(res => {
        this.deptList = []
        this.personList =
          (this.computedFaceStudent ? res.tagStudentInfoList : res) || []
      })
    },
    // 发送ding通知
    async dingNotice(type, noticeItem) {
      mcShowPreloader()
      // 0: 通知家长授权学生录脸 1: 通知家长录入学生人脸 2: 通知大家录入人脸
      let text = ''
      let title = ''
      let url = ''
      let api = ''
      switch (type) {
        case 0:
          api = 'getFaceAgreeList'
          text = `请授权${this.corpName}代家长为学生及家庭成员录入人脸`
          title = '授权同意书'
          url = `${this.h5Host}/?corpId=${this.corpId}#/?redircetHash=/faceInput/rule&campusId=${this.campusId}&role=1&currentRole=1`
          break
        case 1:
          api = 'getFaceNoticeList'
          text = `请${this.corpName}的家长为学生录入人脸，可实时收到学生入离校、出勤状况通知`
          title = '录入人脸照片'
          url = `${this.h5Host}/?corpId=${this.corpId}#/?redircetHash=faceInput/guardian&campusId=${this.campusId}&role=1&currentRole=1`
          break
        case 2:
          api = 'faceQueryGuardianNoticeList'
          text = `管理员${this.dingUserName}通知你录入人脸照片，用于刷脸进出校，点击下方链接一键录入`
          title = '录入人脸照片'
          url = `${this.h5Host}/?corpId=${this.corpId}#/?redircetHash=faceInput/guardian&campusId=${this.campusId}&role=1&currentRole=1`
          break
      }
      let users = []
      if (noticeItem) {
        users = this.computedFaceStudent
          ? noticeItem.guardians
          : [noticeItem.userDingId]
      } else {
        try {
          users = await this.getApi(
            api,
            {
              sandboxId: this.faceSandBoxId,
              deptIds: this.parentNode.deptTpId
                ? [this.parentNode.deptTpId]
                : null,
              ...this.commonParams,
              operUserDingId: this.dingUserId,
              operUserName: this.dingUserName
            },
            true
          )
        } catch (error) {
          console.log(error)
        }
      }
      console.log('发ding', users)

      mcCreateMessage({
        users,
        corpId: this.corpId,
        text,
        attachment: {
          title,
          text: '一键录入，简单高效',
          url,
          image: `${this.h5Host}/static/img/ding-notice.png`
        }
      })
    },
    createSandBox() {
      this.getApi(
        'createFaceSandbox',
        {
          calDeptAllMemberCnt: true,
          sandboxType: this.faceSandBoxType,
          ...this.commonParams,
          operUserDingId: this.dingUserId,
          operUserName: this.dingUserName
        },
        true
      ).then(res => {
        this.faceSandBoxId = res
        this.taskPolling()
      })
    },
    taskPolling() {
      console.log('taskPolling')
      if (this.isDestroyed) {
        mcHidePreloader()
        return false
      }

      this.getApi('getFaceSandboxStatus', {
        sandboxId: this.faceSandBoxId,
        ...this.commonParams,
        operUserDingId: this.dingUserId,
        operUserName: this.dingUserName
      }).then(res => {
        switch (res.sandboxStatus) {
          case 2:
            // 沙盒已准备好，保存一下沙盒ID
            this.getSubNodes()
            break
          case 8:
            this.createSandBox()
            break
          default:
            this.timer = setTimeout(() => {
              this.taskPolling()
            }, 1500)
            break
        }
      })
    },
    getSubNodes() {
      // 点击班级-查人
      if (this.parentNode.type === 3) {
        this.getApi(
          this.computedFaceStudent
            ? 'getFaceStudentMembers'
            : 'getFaceGuardianMembers',
          {
            classId: this.parentNode.deptTpId,
            ...this.commonParams,
            operUserDingId: this.dingUserId,
            operUserName: this.dingUserName
          },
          true
        ).then(res => {
          this.deptList = []
          this.personList = (res || {}).list || []
          this.unFacedCount = (res || {}).unFacedCount || 0
          this.isLoading = false
          mcHidePreloader()
        })
      } else {
        // 查部门
        this.faceSandBoxId &&
          this.getApi('getFaceSandboxSubNodes', {
            parentDeptId: this.parentNode.deptTpId || null,
            sandboxId: this.faceSandBoxId,
            ...this.commonParams,
            operUserDingId: this.dingUserId,
            operUserName: this.dingUserName
          })
            .then(res => {
              this.personList = []
              this.deptList = (res || {}).list || []
              this.unFacedCount = (res || {}).unFacedCount || 0
              this.isLoading = false
              // 当前为单个班级班主任，触发特殊逻辑，跳转内页
              if (
                this.deptList.length === 1 &&
                this.curIsCampusHeadmaster &&
                !this.curIsAdmin &&
                !this.$store.getters.memberFaceIsHeadmasterPage
              ) {
                this.$store.commit('memberFaceIsHeadmasterPage', true)
                this.nextSeason(this.deptList[0])
              }
            })
            .finally(() => {
              mcHidePreloader()
            })
      }
    },
    nextSeason(item, isReplace) {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      let breadList = deepCopy(this.breadList || [])
      this.parentNode = item
      this.breadList = [...breadList, item]
      this.getSubNodes()
      this.$nextTick(() => {
        this.$refs.breadcrumbs.scrollTo(9999, 0)
      })
    },
    back(item, index) {
      this.breadList.splice(index + 1)
      this.parentNode = item
      this.getSubNodes()
    },
    getFaceAuth() {
      if (!getItem('faceauth')) {
        // 录脸授权
        this.getApi(
          'getFaceAuth',
          {
            memberId: this.orgUserId,
            orgId: this.orgId,
            ...this.commonParams,
            operUserDingId: this.dingUserId,
            operUserName: this.dingUserName
          },
          false
        ).then(res => {
          setItem('faceauth', res)
        })
      }
    },
    handlerPerson(item = {}) {
      const faceOpList = [
        { name: '查看人脸', value: 0 },
        { name: '删除人脸', value: 1 }
      ]
      const noticeList = [
        { name: '通知家长授权学校录脸', value: 2 },
        { name: '通知家长帮录入', value: 3 }
      ]
      const adminNoticeList = [
        { name: '拍照录入', value: 4 },
        { name: '通知家长帮录入', value: 3 }
      ]
      const guardianNoticeList = [
        { name: '拍照录入', value: 4 },
        { name: '通知自行录入', value: 5 }
      ]
      // const adminNoticeList = [{ name: '拍照录入', value: 6 }]

      this.showBottom = false
      const title =
        deptMaxName(item.name || item.memberName || item.studentName, 5) +
        (item.face ? `将无法刷脸，确定删除吗？` : '')
      let actions = []
      // 如果已经录入人脸 则有查看和删除功能
      if (item.face) {
        actions = faceOpList
      } else {
        if (this.computedFaceStudent) {
          // 家长是否授权
          if (item.agree) {
            // 管理员操作
            actions = adminNoticeList
          } else {
            // 无家长 邀请家长
            const guardians = item.guardians || []
            if (!guardians.length) {
              mcAlert({
                title: '操作失败',
                msg: '请先邀请家长加入家校通讯录。',
                buttonName: '我知道了'
              })
              this.showBottom = true
              return false
            } else {
              actions = noticeList
            }
          }
        } else {
          // 家长操作
          actions = guardianNoticeList
        }
      }
      const _that = this
      this.$ActionSheet({
        title,
        cancelText: '取消',
        actions,
        onChoose(itm, index) {
          _that.showBottom = true

          switch (itm.value) {
            case 0:
              // 查看人脸
              _that
                .getApi(
                  'getFaceUserInfo',
                  {
                    memberId: item.memberId || item.studentId,
                    ..._that.commonParams,
                    operUserDingId: _that.dingUserId,
                    operUserName: _that.dingUserName
                  },
                  true
                )
                .then(res => {
                  _that.personList.forEach(person => {
                    if (
                      [person.memberId, person.studentId].includes(res.memberId)
                    ) {
                      _that.$set(person, 'facePicUrl', res.facePicUrl)
                    }
                  })
                })
              break
            case 1:
              // 删除人脸
              _that
                .getApi(
                  'faceClear',
                  {
                    sandboxId: _that.faceSandBoxId,
                    memberId: item.memberId || item.studentId,
                    ..._that.commonParams,
                    operUserDingId: _that.dingUserId,
                    operUserName: _that.dingUserName
                  },
                  true
                )
                .then(res => {
                  _that.personList.forEach(person => {
                    if (
                      (item.memberId || item.studentId) ===
                      (person.memberId || person.studentId)
                    ) {
                      _that.$set(person, 'facePicUrl', '')
                      _that.$set(person, 'face', false)
                    }
                  })
                  _that.getSubNodes()
                })
              break
            case 2:
              // 通知家长授权学生录脸
              _that.dingNotice(0, item)
              break
            case 3:
              // 通知家长帮录入
              _that.dingNotice(1, item)
              break
            case 4:
              // 拍照录入 todo
              const url = faceUrl(
                _that.orgId,
                item.memberId || item.studentId,
                _that.orgUserId
              )
              _that.$router.push({
                path: '/faceInput/faceFrame',
                query: { url }
              })
              // mcOpenLink({ url: url })
              // window.location.href = url
              break
            case 5:
              // 通知家长自行录入
              _that.dingNotice(2, item)
              break
          }
        },
        onCancel() {
          _that.showBottom = true
        }
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped>
.no-record {
  .no-course {
    width: 180px;
    height: 180px;
    &.no-item {
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
.address-nav {
  overflow-y: hidden;
  overflow-x: scroll;
  & > div {
    flex-shrink: 0;
  }
}
.face-margin {
  padding: 0 calc((100% - 304px) / 8) 0; //76*4+16
}
.face-pic {
  background-repeat: no-repeat;
  background-position: center center;
}
.c-191A26-24 {
  color: rgb(25, 26, 38, 0.24);
}
.c-#ff5219 {
  color: #ff5219 !important;
}
</style>
